import angular from 'angular';

import MonthNameFilter from './monthName.filter';
import TelephoneFilter from './telFilter';
import CapitalizeFilter from './capitalize.filter';
import DashPercentageFilter from './dashPercentage.filter';
import NumericMaskFilter from './numericMask.filter';
import RangeFilter from './range.filter';
import ZeroDashCurrencyFilter from './zeroDashCurrency.filter';

export default angular.module('app.common.filters', [])
    .filter('monthName', MonthNameFilter)
    .filter('tel', TelephoneFilter)
    .filter('capitalize', CapitalizeFilter)
    .filter('dashPercentage', DashPercentageFilter)
    .filter('numMask', NumericMaskFilter)
    .filter('makeRange', RangeFilter)
    .filter('zeroDashCurrency', ZeroDashCurrencyFilter)
    .name;



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/index.js